const FIELD_TYPES = {
  TEXT: 'text',
  EMAIL: 'email',
  NUMBER: 'number',
  PASSWORD: 'password',
  LABEL: 'label',
  RICH_TEXT: 'richtext',
  EXPRESSION_EDITOR: 'expressioneditor',
  COMMENT: 'comment',
  DATETIME: 'datetime-local',
  DATE: 'date',
  TIME: 'time',
  CHECKBOX: 'checkbox',
  CHECKBOX_LIST: 'checkboxlist',
  RADIO_BUTTON_LIST: 'radiobuttonlist',
  SQL_CHOSEN: 'sqlchoosen',
  DROPDOWN: 'dropdownlist',
  MULTISELECT: 'multiselect',
  SUB_FORM: 'subform',
  SUB_FORM_FIELD: 'subFormField',
  W_PAINT: 'wpaint',
  GPS: 'gps',
  SIGNATURE: 'signature',
  CAMERAS: 'cameras',
  SLIDER: 'slider',
  MAP: 'map',
  LINK: 'link',
  RATING: 'rating',
  CAPTCHA: 'captcha',
  STATUS: 'status',
  BOOLEAN: 'boolean',
  LIST: 'list',
  COMPUTED_LABEL: 'computedLabel',
}

const FIELD_PROPS = {
  HIDDEN: 'hidden',
  READ_ONLY: 'readOnly',
  TYPE_OPTIONS: 'typeOptions',
  LABEL: 'label',
  LIST: 'list',
  FILTER: 'list',
  REQUIRED: 'required',
  VALUE: 'value',
  FORMATTED_VALUE: 'formattedValue',
  OBJECT: 'object',
  AUTOCOMPLETE: 'autocomplete',
}

const SUB_FORM_PROPS = {
  ID: 'id',
  ITEMS: 'items',
  ROWS: 'rows',
  SUB_FORM: 'subForm',
  PROTO: 'proto',
  SUB_ID_FORM: 'subIdForm',
}

module.exports = {
  FIELD_TYPES,
  FIELD_PROPS,
  SUB_FORM_PROPS,
}
